// Метрики на поля в форме
export default function formMetrix() {
  const EDUCATION = document.getElementById("education-level"),
    DATE = document.getElementById("date");

  let selectedOnceEducation = false,
    selectedOnceDate = false;

  if (EDUCATION) {
    EDUCATION.onchange = function () {
      if (!selectedOnceEducation) {
        ym(100783979, "reachGoal", "form_education");
        selectedOnceEducation = true;
      }
    };
  }

  if (DATE) {
    DATE.onchange = function () {
      if (!selectedOnceDate) {
        ym(100783979, "reachGoal", "form_start_education");
        selectedOnceDate = true;
      }
    };
  }
}
